// extracted by mini-css-extract-plugin
module.exports = {"StatusA":"StatusA_StatusA__AuIOT"};